import React from 'react';
import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

interface ResourceCardProps {
  title: string;
  description: string;
  category: string;
  readTime: string;
  image: string;
  alt: string;
  downloadable?: boolean;
}

const ResourceCard = ({ 
  title, 
  description, 
  category, 
  readTime, 
  image, 
  alt,
  downloadable = false 
}: ResourceCardProps) => {
  return (
    <div className="bg-card rounded-lg overflow-hidden shadow-subtle hover:shadow-elevation transition-all duration-300 group">
      <div className="relative h-48 overflow-hidden">
        <AppImage 
          src={image} 
          alt={alt}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
        />
        <div className="absolute top-4 left-4">
          <span className="px-3 py-1 bg-accent text-white text-xs font-semibold rounded-full">
            {category}
          </span>
        </div>
        {downloadable && (
          <div className="absolute top-4 right-4">
            <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center shadow-md">
              <Icon name="ArrowDownTrayIcon" size={16} className="text-primary" />
            </div>
          </div>
        )}
      </div>
      
      <div className="p-6">
        <div className="flex items-center space-x-2 text-sm text-muted-foreground mb-3">
          <Icon name="ClockIcon" size={16} />
          <span>{readTime}</span>
        </div>
        
        <h3 className="text-xl font-display font-semibold text-foreground mb-2 group-hover:text-primary transition-colors duration-300">
          {title}
        </h3>
        
        <p className="text-muted-foreground mb-4 line-clamp-2">
          {description}
        </p>
        
        <button className="flex items-center space-x-2 text-primary font-semibold hover:text-accent transition-colors duration-300">
          <span>{downloadable ? 'Download Resource' : 'Read More'}</span>
          <Icon name="ArrowRightIcon" size={16} />
        </button>
      </div>
    </div>
  );
};

export default ResourceCard;